<template>
    <div class="entity-modal">
        <TitleBaseBox :title="title" @close="close" @confirm="confirmClick">
            <div class="entity-content">
                <el-form label-position="left" :model="entityForm" :rules="rules" ref="ruleForm" label-width="120px">
                    <el-form-item label="分类" prop="classifyId">
                        <el-select
                            :style="{ width: '50%' }"
                            v-model="entityForm.classifyId"
                            placeholder="请选择"
                            :disabled="data.type === 'add' && data.entityData.classify_id !== ''"
                        >
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="实体组名称" prop="entityGroupName">
                        <el-input :style="{ width: '50%' }" v-model="entityForm.entityGroupName" placeholder="建议输入中文"></el-input>
                    </el-form-item>
                    <el-form-item label="实体名称" prop="entityList">
                        <!-- 实体列表 -->
                        <EntityList v-model="entityForm.entityList" :type="data.type" />
                    </el-form-item>
                    <el-form-item :label="data.type === 'add' ? '兜底标问' : '关联标问（默认语种的标问ID）'" prop="questionId">
                        <!-- 管理标问id -->
                        <EntityQuestion
                            v-model="entityForm.questionId"
                            :questionDetail="entityForm.questionDetail"
                            @changeQuestion="changeQuestion"
                        />
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <div class="entity-status">
                            <el-switch v-model="entityForm.status" active-color="#2ec2ff" inactive-color="#e2e2e2"> </el-switch>
                            <span v-show="entityForm.status"> 上线启用</span>
                            <span v-show="!entityForm.status"> 暂不上线（仅保存）</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import EntityList from "./EntityList.vue";
import EntityQuestion from "./EntityQuestion.vue";
import { addEntity, editEntity } from "../server";

export default {
    name: "EntityModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        EntityList,
        EntityQuestion
    },
    data() {
        var validatePass2 = (rule, value, callback) => {
            if (Object.values(value).some(item => item == "")) {
                // 有空值 通过class类名区分验证失败的input
                callback(new Error("实体名称不能为空"));
            }
            callback();
        };
        return {
            title: this.data.title,
            entityForm: {
                classifyId: this.data.entityData.classify_id || "",
                entityGroupName: this.data.entityData.entity_group_name || null,
                entityList: this.data.entityData.entity_list || {},
                questionId: this.data.entityData.question_id || "",
                questionDetail: this.data.entityData.question_id ? `${this.data.entityData.question_id}-${this.data.entityData.question_name}` : "",
                status: !!(this.data.type === "edit" ? this.data.entityData.status : 1),
            },
            options: [
                //分类选项 data把选项传进来
                ...this.data.classifyOptions
            ],
            rules: {
                classifyId: [{ required: true, message: "请选择分类", trigger: "change" }],
                entityGroupName: [{ required: true, message: "请输入实体组名称", trigger: "blur" }],
                entityList: [
                    { required: true, trigger: "blur" },
                    { validator: validatePass2, trigger: "blur" }
                ],
                questionId: [{ required: true, message: "请选择关联标问", trigger: "change" }],
                status: [{ required: true }]
            },
        };
    },
    methods: {
        changeQuestion(value) {
            this.entityForm.questionDetail = value;
        },
        close() {
            this.$emit("closeModal");
        },
        confirmClick() {
            this.$refs.ruleForm.validate(async res => {
                if (res) {
                    const { entityGroupName, questionId, classifyId, status, entityList } = this.entityForm;
                    const mapEntityList = {};
                    for (const key in entityList) {
                        if (Object.hasOwnProperty.call(entityList, key)) {
                            mapEntityList[key] = entityList[key].split("；");
                        }
                    }
                    if (this.data.type === "add") {
                        await addEntity({
                            gameId: this.$store.state.zhiji.gameState.gameId,
                            entityGroupName,
                            questionId,
                            classifyId,
                            status: status ? 1 : 0,
                            entityList: JSON.stringify(mapEntityList)
                        });
                    } else {
                        await editEntity({
                            gameId: this.$store.state.zhiji.gameState.gameId,
                            entityGroupId: this.data.entityData.entity_group_id,
                            entityGroupName,
                            questionId,
                            classifyId,
                            status: status ? 1 : 0,
                            entityList: JSON.stringify(mapEntityList)
                        });
                    }
                    this.data.confirm && this.data.confirm(status);
                    this.close();
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
.entity-modal {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(65, 71, 94, 0.4);
    .entity-content {
        width: 640px;
        .entity-status {
            margin-top: 5px;
        }
        /deep/.el-form-item {
            margin-bottom: 32px;
        }
        /deep/.el-form-item.is-error {
            .is-error-input {
                .el-input__inner {
                    border-color: #fe0931;
                }
            }
        }
    }
}
</style>
